// src/pages/AllProducts.js
import { useState, useEffect, useContext } from "react";
import {
  collection,
  collectionGroup,
  doc,
  documentId,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import {
  auth,
  db,
  getFirebaseToken,
  getUserDataById,
} from "../utils/firebase/firebase.utils";
import {
  GetAllMyFollowers,
  SetNotifications,
} from "../features/Products/ProductSlice";
import { UserContext } from "../context/user.context";
import { useDispatch } from "react-redux";
import {
  NOTIFICATION_TYPE_BALANCE_ACCEPTED,
  NOTIFICATION_TYPE_BALANCE_REJECTED,
  NOTIFICATION_TYPE_BID_ACCEPTED,
  NOTIFICATION_TYPE_BID_PRICE_COUNTER,
  NOTIFICATION_TYPE_BID_PRICE_FIRST,
  NOTIFICATION_TYPE_BID_REJECTED,
} from "../constants/constants";
import { AiOutlineConsoleSql } from "react-icons/ai";
export const AllProducts = () => {
  const [notifications, setNotifications] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bidUsers, setBidUsers] = useState({});
  console.log(bidUsers, "bidUsers");
  const dispatch = useDispatch();
  const { currentUser } = useContext(UserContext);
  // Console log for debugging

  // async function getBid11Messages() {
  //   try {
  //     const messagesRef = collection(db, "messages");
  //     const queries = [
  //       query(
  //         messagesRef,
  //         where("type", "==", "BID11"),
  //         where("idSender", "==", currentUser.uid)
  //       ),
  //       query(
  //         messagesRef,
  //         where("type", "==", "BID11"),
  //         where("idReceiver", "==", currentUser.uid)
  //       ),
  //     ];

  //     const [senderSnap, receiverSnap] = await Promise.all(
  //       queries.map(getDocs)
  //     );

  //     const allMessages = [
  //       ...senderSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
  //       ...receiverSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
  //     ];

  //     // Remove duplicates by ID
  //     return Array.from(
  //       new Map(allMessages.map((msg) => [msg.id, msg])).values()
  //     );
  //   } catch (error) {
  //     console.error("Error fetching messages:", error);
  //     return [];
  //   }
  // }

  // async function getUserDataById(userId) {
  //   try {
  //     const userRef = doc(db, "users", userId);
  //     const userSnap = await getDoc(userRef);
  //     return userSnap.exists() ? { id: userSnap.id, ...userSnap.data() } : null;
  //   } catch (error) {
  //     console.error("Error getting user:", error);
  //     return null;
  //   }
  // }

  // async function getProductAndUserModel(notification, messages) {
  //   console.log(messages, "all messages");
  //   const bidId = notification.content;
  //   const msg = messages?.filter((msg) => msg?.content?.includes(bidId))[0];
  //   const uidSender = msg?.idSender;

  //   let idUser = uidSender;

  //   if (idUser) {
  //     return await getUserDataById(idUser);
  //   }

  //   return null;
  // }

  // Modified useEffect for notifications
  // useEffect(() => {
  //   const fetchBidUsers = async () => {
  //     if (!notifications.length || !currentUser) return;

  //     setLoading(true);

  //     try {
  //       // Filter only relevant notifications
  //       const bidNotifications = notifications.filter((notf) =>
  //         [
  //           "bidPrice",
  //           NOTIFICATION_TYPE_BID_REJECTED,
  //           NOTIFICATION_TYPE_BID_PRICE_COUNTER,
  //           NOTIFICATION_TYPE_BID_PRICE_FIRST,
  //         ].includes(notf.type)
  //       );

  //       // Get all relevant BID11 messages
  //       const messages = await getBid11Messages();
  //       if (!Array.isArray(messages)) throw new Error("Messages not an array");

  //       const newUsersData = {};
  //       const userCache = new Map(); // Cache to avoid duplicate fetches

  //       for (const notf of bidNotifications) {
  //         try {
  //           const bidId = notf.content;
  //           const msg = messages.find((m) => m?.content?.includes(bidId));
  //           const userId = msg?.idSender;

  //           if (userId && !userCache.has(userId)) {
  //             const user = await getUserDataById(userId);
  //             if (user) {
  //               userCache.set(userId, user);
  //               newUsersData[notf.id] = user;
  //             }
  //           } else if (userCache.has(userId)) {
  //             newUsersData[notf.id] = userCache.get(userId);
  //           }
  //         } catch (err) {
  //           console.error("Error getting user for notification:", notf.id, err);
  //         }
  //       }

  //       setBidUsers((prev) => ({ ...prev, ...newUsersData }));
  //     } catch (err) {
  //       console.error("Error in fetchBidUsers:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchBidUsers();
  // }, [notifications, currentUser?.uid]);

  // storing notifications
  // useEffect(() => {
  //   if (currentUser) {
  //     var today = new Date();
  //     var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  //     var notificationRef = query(
  //       collection(db, "notifications"),
  //       where("date", ">=", priorDate),
  //       where("toUid", "==", currentUser.uid)
  //     );
  //     onSnapshot(notificationRef, (snapshot) => {
  //       setNotifications(
  //         snapshot.docs
  //           .filter((doc) => !doc.data().status)
  //           .map((doc) => ({
  //             ...doc.data(),
  //             id: doc.id,
  //           }))
  //       );
  //       dispatch(
  //         SetNotifications(
  //           snapshot.docs
  //             .filter((doc) => !doc.data().status)
  //             .map((doc) => ({
  //               ...doc.data(),
  //               id: doc.id,
  //             }))
  //         )
  //       );
  //     });

  //     if (currentUser) {
  //       getFirebaseToken(currentUser.token, currentUser.uid);
  //     }
  //     const followingQuery = query(
  //       collection(db, "following"),
  //       where("idFollowFrom", "==", currentUser.uid)
  //     );
  //     onSnapshot(followingQuery, (snapshot) => {
  //       dispatch(
  //         GetAllMyFollowers(
  //           snapshot.docs
  //             .filter((doc) => !doc.data().status)
  //             .map((doc) => ({
  //               ...doc.data(),
  //               id: doc.id,
  //             }))
  //         )
  //       );
  //     });
  //   }
  // }, [currentUser]);
  console.log(bidUsers?.length, "bidUsers length");
  console.log(notifications, "notifaction");
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const querySnapshot = await getDocs(
          collection(db, "product"),
          where("status", "==", "Live")
        );
        const productsData = [];

        querySnapshot.forEach((doc) => {
          productsData.push({
            id: doc.id,
            ...doc.data(),
          });
        });

        setProducts(productsData);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);
  if (loading) {
    return <div>Loading products...</div>;
  }

  return (
    <div className="seo-product-directory montserrat-font">
      <h1 style={{ fontSize: "20px", padding: "20px" }}>
        All Libas Products ({products.length})
      </h1>
      <div className="seo-product-directory" style={{ display: "none" }}>
        <h1 aria-hidden="true">All Products</h1>
        <ul>
          {" "}
          {/* Semantic HTML list */}
          {products?.map((product) => (
            <li key={product?.id}>
              <a
                href={`/product/${product?.id}`}
                aria-label={`View ${product?.nameBrand || "product"}`}
              >
                {product?.nameBrand || `Product ${product.id}`}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
